import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { AuthenticationSelectors, ConfigService } from '@orion-platform/core';
import { environment } from '@orion/environment';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PlantHealthCheckService {
  /**
   *Creates an instance of FeedbackService.
   * @param {HttpClient} http
   * @param {ConfigService} configService
   * @param {Store} store
   * @memberof FeedbackService
   */

  constructor(
    private readonly http: HttpClient,
    private readonly configService: ConfigService,
    private store: Store,
  ) {}

  /**
   * Get plant status
   * @returns
   * @memberof PlantHealthCheckService
   */
  async checkHealth(plant?: string): Promise<unknown> {
    let apiUrl = this.configService.getSettings('apiBaseUrl') as string;
    if (plant === undefined) {
      plant = this.store.selectSnapshot(AuthenticationSelectors.activePlant);
    }
    apiUrl = plant ? apiUrl.replace('__plant__', plant) : apiUrl;

    const data = await firstValueFrom(
      this.http.get(`${apiUrl}${environment.plantHealthCheck.checkHealth}`, {
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
          Expires: '0',
          Pragma: 'no-cache',
        },
        observe: 'response',
      }),
    );
    return data;
  }
}
